import script from "./LocinderGPS.vue?vue&type=script&setup=true&lang=js"
export * from "./LocinderGPS.vue?vue&type=script&setup=true&lang=js"

import "./LocinderGPS.vue?vue&type=style&index=0&id=46802d52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46802d52"]])

export default __exports__